export default __webpack_public_path__ + "static/media/hedge.a1e6b267.png";